import React, {memo, Fragment} from "react";
import {useDispatch, useSelector} from "react-redux";
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import { handleSetOpenCustomSnackbar } from 'reduxx/actions/snackbar';


const CustomSnackbar = () => {

    const dispatch = useDispatch();
    const {open, vertical, horizontal, severity, variant, message} = useSelector(state => state.custom_snackbar); 
    



    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        dispatch(handleSetOpenCustomSnackbar(false));
    };

    const action = (
        <Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </Fragment>
    );

    return (
        <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            style={{direction: 'ltr'}}
            open={open}
            autoHideDuration={5000}
            onClose={handleClose}
            action={action}
            key={vertical + horizontal} >

            <Alert onClose={handleClose} severity={severity} variant={variant} sx={{ width: '100%' }}>
                {message}
            </Alert>

        </Snackbar>

    );
};

export default memo(CustomSnackbar);
